export default __webpack_public_path__ + "static/media/Meditation_16_9.590de82e.png";